import React from "react";
import "./CSS/LoginSignUp.css";

const LoginSignUp = () => {
    return (
        <div className="loginsignup">
            <div className="loginsignup-container">
                <h1>Sign Up</h1>
                <div className="loginsignup-fields">
                    <input type="text" placeholder="Name" required />
                    <input type="email" placeholder="Email" required />
                    <input type="password" placeholder="Password" required />
                </div>
                <button>Continue</button>
                <p>Already have an account? <a href="/login"><span>Login here</span></a></p>
                <div className="loginsignup-agree">
                    <input type="checkbox" name="" id="" required />
                    <p>I agree to the <span>Terms and Conditions</span></p>
                </div>
                <p>By continuing, you agree to our <span>Terms and Conditions</span></p>
                <p>and <span>Privacy Policy</span></p>
            </div>
        </div>
    );
}

export default LoginSignUp;